import { fmtNum } from "@/lib/format";

/** A progress update above the planned quantity is saved (rework and scope growth are real), but the person entering it is told.
 *  `item` is the WBS item the progress API sends back after the update. Returns the message, or null when nothing is over. */
export function overPlanMessage(item) {
  const planned = Number(item?.quantity);
  const done = Number(item?.construction?.cum_actual_qty);
  if (!(planned > 0) || !(done > planned)) return null;
  return `Saved, but ${fmtNum(done, 2)} is now done against ${fmtNum(planned, 2)} planned. Check the quantity, or raise the planned quantity if the scope grew.`;
}

/** Progress is capped at 100%: the screen refuses a quantity that would take an activity past its plan (the server refuses it too).
 *  `planned` and `done` come from the activity; `after` is the done quantity once this entry counts. Returns the message, or null. */
export function overCapMessage({ planned, done, after, unit }) {
  const plan = Number(planned);
  const total = Number(after);
  if (!(plan > 0) || !(total > plan)) return null;
  const left = Math.max(plan - Number(done || 0), 0);
  const u = unit ? ` ${unit}` : "";
  return `This would take the activity to ${fmtNum(total, 3)}${u}, ${((total / plan) * 100).toFixed(1)}% of the planned ${fmtNum(plan, 3)}${u}. `
    + `Progress cannot go above 100%; at most ${fmtNum(left, 3)}${u} more can be recorded.`;
}
